

export default function ExaminationReport() {


    return (
        <div className="ml-3 mr-3" >
            <h3 className="mb-3 text-pp-secondary font-weight-bold">Examination Report</h3>         
        </div>
    );
}